// ABOUTME: Conditionally wraps children with PostHogProvider when the API key is configured.
// ABOUTME: Renders children unchanged when VITE_POSTHOG_KEY is absent (e.g. in test environments).
import { type ReactNode } from 'react'
import { PostHogProvider } from 'posthog-js/react'

const posthogKey = import.meta.env.VITE_POSTHOG_KEY as string | undefined
const posthogHost = import.meta.env.VITE_POSTHOG_HOST as string | undefined

export function AnalyticsProvider({ children }: { children: ReactNode }) {
  if (!posthogKey) return <>{children}</>
  return (
    <PostHogProvider apiKey={posthogKey} options={{ api_host: posthogHost }}>
      {children}
    </PostHogProvider>
  )
}
